import { useEffect } from 'react';

interface BeaconFunction {
  (method: string, options?: unknown, data?: unknown): void;
  readyQueue?: Array<{ method: string; options?: unknown; data?: unknown }>;
  initialized?: boolean;
}

declare global {
  interface Window {
    Beacon?: BeaconFunction;
  }
}

export const useHelpScout = (beaconId: string) => {
  useEffect(() => {
    if (window.Beacon?.initialized) return; // prevent double init

    // Step 1: Create the script injection function
    const beaconLoader = () => {
      const firstScript = document.getElementsByTagName('script')[0];
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://beacon-v2.helpscout.net';
      firstScript.parentNode?.insertBefore(script, firstScript);
    };

    (function (e: Window, t: Document) {
      if (e.Beacon) return;
      const readyQueue: Array<{
        method: string;
        options?: unknown;
        data?: unknown;
      }> = [];
      const beaconFn: BeaconFunction = function (
        method: string,
        options?: unknown,
        data?: unknown,
      ) {
        readyQueue.push({ method, options, data });
      };
      beaconFn.readyQueue = readyQueue;
      e.Beacon = beaconFn;

      if (t.readyState === 'complete') {
        beaconLoader();
      } else {
        t.addEventListener('load', beaconLoader, false);
      }
    })(window, document);

    // Step 3: Initialize with your Beacon ID
    window.Beacon?.('init', beaconId);
    if (window.Beacon) {
      window.Beacon.initialized = true;
    }
  }, [beaconId]);
};
